export enum productchangeType  {
        Adhoc = 1,
        productchange = 2,
        Editapplication = 3,
        WaterfallProductChange = 4
}
